import getPricesForAssets from '../../utils/data/getPricesForAssets';
import * as helpers from '../../utils/helpers'
import config from '@/constants/config'

export let state = {
  btcPrice: null,
  ethPrice: null,
  euroPrice: null,

}

export async function getBTCPrice() {
  const btcPrice = (await getPricesForAssets(['bitcoin']))['bitcoin'];
  state.btcPrice = btcPrice;
  return btcPrice
}

export async function getEuroPrice() {
  const euroPrice = (await getPricesForAssets(['stasis-eurs']))['stasis-eurs'];
  state.euroPrice = euroPrice;
  return euroPrice
}

export async function getLinkPrice() {
  const chainlinkPrice = (await getPricesForAssets(['chainlink']))['chainlink'];
  state.ethPrice = chainlinkPrice;
  return chainlinkPrice
}


export async function getEthPrice() {
  const ethPrice = (await getPricesForAssets([config.coingeckoAssetId]))[config.coingeckoAssetId];
  state.ethPrice = ethPrice;
  return ethPrice
}
